import readXlsxFile from 'read-excel-file';

export const readExcelFile = async (file) => {
    const data = []
    const readFile = await readXlsxFile(file)
    readFile.forEach(row => {
        data.push({
            leadName: row[0] ? row[0] : '',
            email: row[1] ? row[1] : '',
            source: row[2] ? row[2] : '',
            contactName: row[3] ? row[3] : '',
            phone: row[4] ? row[4] : '',
            address: row[5] ? row[5] : '',
            province: row[6] ? row[6] : '',
            note: row[7] ? row[7] : '',
        })
    })
    // console.log(data)
    return data;
}

export const checkLeadDataValidity = (data) => {
    let valid = true;
    data.forEach(lead => {
        if (!lead.leadName || !lead.email) {
            valid = false;
        }
    })
    return valid;
}

export const checkForDuplicateLead = (data) => {
    let duplicate = false;
    const leadNames = data.map(lead => lead.leadName.toLowerCase());
    const uniqueLeadNames = [...new Set(leadNames)];
    const leadEmails = data.map(lead => lead.email.toLowerCase());
    const uniqueLeadEmails = [...new Set(leadEmails)];
    if (leadNames.length !== uniqueLeadNames.length || leadNames.length !== uniqueLeadEmails.length) {
        duplicate = true;
    }
    return duplicate;
}